import { useMemo } from "react";
import { ApiError, createApiClient, type ApiOptions } from "@am/shared";

// In production the React bundle is served from the same FastAPI origin, so
// relative URLs (/tenant/api/...) work. In dev, Vite proxies /tenant/api to
// VITE_API_TARGET, so relative URLs also work.
// Exported so pages that construct non-fetch URLs (e.g. iframe src) can use
// the same base and avoid resolving against the SPA domain instead of the API.
export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

// Module-level token holder. AuthProvider keeps it in sync with React state so
// the API client always sends the latest token without prop-drilling.
let currentToken: string | null = null;

export function setCurrentToken(token: string | null): void {
  currentToken = token;
}

const apiFn = createApiClient(API_BASE, () => {
  const headers: Record<string, string> = {};
  if (currentToken) headers.Authorization = `Bearer ${currentToken}`;
  return headers;
});

export type ApiClient = <T = unknown>(path: string, opts?: ApiOptions) => Promise<T>;

export function useApiClient(): ApiClient {
  return useMemo(() => apiFn, []);
}

export { ApiError };
